var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('setup-table',{ref:"setupTable"}),_c('addTableDialog',{ref:"dataDialog",attrs:{"title":"编辑"},on:{"initTree":_vm.initTree}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }